/* eslint-disable */

export enum DepositFeeStatus {
  /**
   * FREE_INSTANT_DEPOSITS - Customers will get instant deposits for free.
   * Deprecated for US only: Customers are migrated to BPS_FEE_100_LEGACY or BPS_FEE_150_CUTOVER.
   */
  FREE_INSTANT_DEPOSITS = "FREE_INSTANT_DEPOSITS",
  /**
   * BPS_FEE_FOR_INSTANT_DEPOSITS - Customers will be charged 1% for instant deposits.
   * Deprecated: Customers are migrated to BPS_FEE_100_LEGACY or BPS_FEE_150_CUTOVER.
   */
  BPS_FEE_FOR_INSTANT_DEPOSITS = "BPS_FEE_FOR_INSTANT_DEPOSITS",
  /**
   * BPS_FEE_FOR_INSTANT_DEPOSITS_WAS_FREE - Customers who previously had free instant deposits and now are being charged 1% for instant
   * deposits.
   * Deprecated: Customers are migrated to BPS_FEE_100_LEGACY or BPS_FEE_150_CUTOVER.
   */
  BPS_FEE_FOR_INSTANT_DEPOSITS_WAS_FREE = "BPS_FEE_FOR_INSTANT_DEPOSITS_WAS_FREE",
  /**
   * BPS_FEE_FOR_INSTANT_DEPOSITS_WAS_FREE_2 - A second group of customers who previously had free instant deposits and now are being charged
   * 1% for instant deposits. We want to be able to track these separately from customers in
   * BPS_FEE_FOR_INSTANT_DEPOSITS_WAS_FREE while they get the same behavior.
   * Deprecated: Customers are migrated to BPS_FEE_100_LEGACY or BPS_FEE_150_CUTOVER.
   */
  BPS_FEE_FOR_INSTANT_DEPOSITS_WAS_FREE_2 = "BPS_FEE_FOR_INSTANT_DEPOSITS_WAS_FREE_2",
  /**
   * FORCED_FREE_INSTANT_DEPOSITS - Customers with this status are forced to have free instant deposits. Their status cannot be
   * updated implicitly by an experiment. This can only be overridden by forcing another deposit
   * fee status explicitly.
   */
  FORCED_FREE_INSTANT_DEPOSITS = "FORCED_FREE_INSTANT_DEPOSITS",
  /** BPS_FEE_150 - Customers will be charged 1.5% for instant deposits. They get this status at sign up. */
  BPS_FEE_150 = "BPS_FEE_150",
  /**
   * BPS_FEE_150_CUTOVER - Customers will be charged 1.5% for instant deposits. Customers are migrated to this status from
   * ones with a 1% fee if they have never enabled auto cash outs, or if enough time has passed
   * since the last time they had auto cash outs enabled. See also design doc:
   * https://docs.google.com/document/d/1DxhRJIBY919EZC0Y4myXA39Z6Pzh7WZvyJF59YA0nAA/edit
   */
  BPS_FEE_150_CUTOVER = "BPS_FEE_150_CUTOVER",
  /**
   * BPS_FEE_100_LEGACY - Customers will be charged 1% for instant deposits. Customers are migrated to this status from
   * the deprecated ones and stay with this status as long as they have auto cash outs enabled, or
   * if not enough time has passed since auto cash outs were disabled. See also design doc:
   * https://docs.google.com/document/d/1DxhRJIBY919EZC0Y4myXA39Z6Pzh7WZvyJF59YA0nAA/edit
   */
  BPS_FEE_100_LEGACY = "BPS_FEE_100_LEGACY",
  /** BPS_FEE_375 - Cash for Business Customers will be charged  3.75% for instant deposits. */
  BPS_FEE_375 = "BPS_FEE_375",
  /** BPS_FEE_225 - Cash for Business Customers will be charged 2.25% for slow deposits. */
  BPS_FEE_225 = "BPS_FEE_225",
  /** BPS_FEE_175 - Customers will be charged 1.75% for instant deposits. */
  BPS_FEE_175 = "BPS_FEE_175",
}
